import { createApp } from 'vue';
import WordToPngConverter from '@/Components/WordToPngConverter.vue';
import '@styles/app.css';

createApp(WordToPngConverter).mount('#word-to-png-converter');
